angular
    .module('annexaApp')
    .component('annexaAutomaticExecutedActions',{
        templateUrl: './components/admin/annexa-automatic-executed-actions/annexa-automatic-executed-actions.html',
        controller:['Language', '$rootScope', 'AnnexaObjectBoxFactory', 'GlobalDataFactory', '$filter', '$scope', '$state', 'AnnexaFormlyFactory', 'CommonAdminModals', 'DialogsFactory', 'apiAdmin', 'RestService', 'AdminFactory', 
        function(Language, $rootScope, AnnexaObjectBoxFactory, GlobalDataFactory, $filter, $scope, $state, AnnexaFormlyFactory, CommonAdminModals, DialogsFactory, apiAdmin, RestService, AdminFactory) {
            var vm = this;
            vm.languageColumn = Language.getActiveColumn();
            
            vm.deleteAutomatism = function(item, index){
            	if(!vm.objectId){
					vm.actions.splice(index, 1);
				}else{
					if(item && item.id){
						RestService.delete('./api/automatic_executed_action/' + item.id).then(function (data) {
		        			vm.actions.splice(index, 1);
			            }).catch(function (error) {
			            	DialogsFactory.error($filter('translate')('global.errors.unknownDelete'));
			            });
					}else{
						vm.actions.splice(index, 1);
					}
				}	
            }
            
            vm.saveEditAutomatic = function(){
				var self = this;
				if(this.annexaFormly && this.annexaFormly.model && this.annexaFormly.model.modal_body && this.temp && this.temp.item){
					var model = this.annexaFormly.model.modal_body;
					var itemAux = angular.copy(this.temp.item);
					var raField = $linq(this.annexaFormly.fields[0].fieldGroup).firstOrDefault(undefined,"x => x.key == 'relatedAutomatism'");
					var autSelected = undefined;
					if(raField && raField.templateOptions && raField.templateOptions.options){
						autSelected = $linq(raField.templateOptions.options).firstOrDefault(undefined, "x => x.id == "+this.annexaFormly.model.modal_body.relatedAutomatism);	
					}
					if(!vm.objectId){
						self.temp.item.automatism = ((autSelected && autSelected.id)?{id:autSelected.id, language1:autSelected.language1, language2:autSelected.language2, language3:autSelected.language3}:((model.relatedAutomatism)?{id:model.relatedAutomatism, language1:model.relatedAutomatism, language2:model.relatedAutomatism, language3:model.relatedAutomatism}:undefined));
						self.close();
					}else{
						itemAux.automatism =((autSelected && autSelected.id)?{id:autSelected.id, language1:autSelected.language1, language2:autSelected.language2, language3:autSelected.language3}:((model.relatedAutomatism)?{id:model.relatedAutomatism, language1:model.relatedAutomatism, language2:model.relatedAutomatism, language3:model.relatedAutomatism}:undefined));
						itemAux.objectId= vm.objectId;
						RestService.update('./api/automatic_executed_action/' + itemAux.id, itemAux).then(function (data) {
							self.temp.item.automatism = ((autSelected && autSelected.id)?{id:autSelected.id, language1:autSelected.language1, language2:autSelected.language2, language3:autSelected.language3}:((model.relatedAutomatism)?{id:model.relatedAutomatism, language1:model.relatedAutomatism, language2:model.relatedAutomatism, language3:model.relatedAutomatism}:undefined));
			        		self.close();
			            }).catch(function (error) {
			            	DialogsFactory.error($filter('translate')('global.errors.unknownUpdate'));
			            });
					}
				}
			}
            
            vm.editAutomatism = function(item){
            	var modal = angular.copy(CommonAdminModals.automatismRelatedNew);
				modal.annexaFormly.options = {};
				modal.temp = {item:item};
				modal.annexaFormly.model = {modal_body: {
					relatedAutomatism:((item.automatism)?item.automatism.id:undefined),
					relatedIds: $linq(vm.actions).select("x => x.automatism.id").toArray()
				}}
				var viewOrderField = $linq(modal.annexaFormly.fields[0].fieldGroup).firstOrDefault(undefined, "x => x.key == 'viewOrder'");
                if(viewOrderField) {
                	viewOrderField.hideExpression = function ($viewValue, $modelValue, scope) {
                		return true;
                	}
                }
				AnnexaFormlyFactory.showModal('modalAutomatismRelatedEdit', modal, vm.saveEditAutomatic, false);
            }
            
            vm.saveAutomatic = function(){
				var self = this;
				if(this.annexaFormly && this.annexaFormly.model && this.annexaFormly.model.modal_body){
					var model = this.annexaFormly.model.modal_body;
					var raField = $linq(this.annexaFormly.fields[0].fieldGroup).firstOrDefault(undefined,"x => x.key == 'relatedAutomatism'");
					var autSelected = undefined;
					if(raField && raField.templateOptions && raField.templateOptions.options){
						autSelected = $linq(raField.templateOptions.options).firstOrDefault(undefined, "x => x.id == "+this.annexaFormly.model.modal_body.relatedAutomatism);	
					}
					var related = {
						objectType:vm.objectType,
						executedAction:vm.executedAction,
						automatism:((autSelected && autSelected.id)?{id:autSelected.id, language1:autSelected.language1, language2:autSelected.language2, language3:autSelected.language3}:((model.relatedAutomatism)?{id:model.relatedAutomatism, language1:model.relatedAutomatism, language2:model.relatedAutomatism, language3:model.relatedAutomatism}:undefined))
					}
					if(!vm.objectId){
						vm.actions.push(related);
						self.close();
					}else{
						related.objectId = vm.objectId;
						RestService.insert('./api/automatic_executed_action', related).then(function (data) {
							vm.actions.push(data);
			        		self.close();
			            }).catch(function (error) {
			            	DialogsFactory.error($filter('translate')('global.errors.unknownNew'));
			            });
					}
				}
			}
			
            
            vm.newAutomatism = function(){
            	var modal = angular.copy(CommonAdminModals.automatismRelatedNew);
				modal.annexaFormly.options = {};
				modal.annexaFormly.model = {modal_body: {
					relatedIds: $linq(vm.actions).select("x => x.automatism.id").toArray()
				}}
				var viewOrderField = $linq(modal.annexaFormly.fields[0].fieldGroup).firstOrDefault(undefined, "x => x.key == 'viewOrder'");
                if(viewOrderField) {
                	viewOrderField.hideExpression = function ($viewValue, $modelValue, scope) {
                		return true;
                	}
                }
				AnnexaFormlyFactory.showModal('modalAutomaticNew', modal, vm.saveAutomatic, false);
            }
            	
        	this.$onInit = function () {
        		if(!vm.actions ){
        			vm.actions = [];
        		}
            }
        }],
        bindings: {
            actions: '=',
            objectType: '@',
            objectId: '=?',
            executedAction: '@'
        }
    })
